import React from 'react';
import '../css/modal-split-form.css';

const ModalSplitForm = ({ leftForm, rightForm, innerAlert, topAlert }) => (
  <div className="modal-split-form">
    {topAlert}
    <div className="panel-body rounded panel panel-default is-table-row">
      <section className="left-form split">
        {innerAlert}
        {leftForm}
      </section>
      <section className="right-form split">{rightForm}</section>
    </div>
  </div>
);

export default ModalSplitForm;



// WEBPACK FOOTER //
// ./src/desktop/components/modal-split-form.js